
import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'

// 声明全局变量类型
declare const __BASE_PATH__: string;

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
    </BrowserRouter>
  )
}

export default App
